module.exports = __webpack_public_path__ + "static/img/materialsBanner.3eda26e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsBanner.png
// module id = S+0q
// module chunks = 2